var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCollapse = function SvgCollapse(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 18,
    viewBox: "0 0 17.6 17.6",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.838 0a.74.74 0 0 1 .51.24.75.75 0 0 1 0 1l-4.25 4.25h2.93a.75.75 0 0 1 0 1.5h-4.68a.8.8 0 0 1-.33-.08.75.75 0 0 1-.42-.93V1.56a.75.75 0 1 1 1.5 0v2.838L16.348.24a.74.74 0 0 1 .49-.24M1.16 10.909h4.682a.74.74 0 0 1 .528.22.75.75 0 0 1 .22.53v4.68a.75.75 0 0 1-1.5 0v-2.87l-3.83 3.83a.75.75 0 0 1-1.06-1.06l3.83-3.83h-2.87a.75.75 0 1 1 0-1.5",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCollapse);
export default ForwardRef;